import { createSlice } from "@reduxjs/toolkit";

// Создаем slice (редьюсер + экшены)
const calendarSlice = createSlice({
  name: "calendar",
  initialState: { calendar: [], rrr: "sdfsdf" },
  reducers: {
    setCalendar: (state, action) => {
      state.calendar = action.payload;
      localStorage.setItem("calendar", action.payload);
    },
  },
});

// Экшены
export const { setCalendar } = calendarSlice.actions;

export default calendarSlice.reducer;
